import { createAction, props } from '@ngrx/store';

export const getActivities = createAction('[ACTIVITIES] get activities', props<{payload: any}>());
export const getActivitiesSuccess = createAction('[ACTIVITIES] get activities success', props<{ activities: any }>());
export const addActivity = createAction('[ACTIVITIES] add activity', props<{ payload: any }>());
export const updateActivity = createAction('[ACTIVITIES] update activity', props<{ payload: any }>());
export const deleteActivity = createAction('[ACTIVITIES] delete activity', props<{ payload: any }>());
export const deleteActivitySuccess = createAction('[ACTIVITIES] delete activity success', props<{ payload: any }>());
export const setAllActivities = createAction('[ACTIVITIES] add activity success', props<{ payload: any }>());
